module.exports = __webpack_public_path__ + "static/media/empty.e45c9b91.svg";